import React from 'react';
import { Modal, Row, Col, Input, Form, Button } from 'antd';
import moment from 'moment';
// import { UploadImg } from '@HOC';
import { getData } from '@util';
// import { getVariantSession, LOGIN_TOKEN } from '@Variant';
import {
  // POST_FILE_UPLOAD_WHITE,
  // POST_FILE_UPLOAD_OCRWHITE,
  // POST_FILE_UPLOAD_FOOD_PRODUCE_LICENSE_WHITE_OCRWHITE,
  ADDMANUFACTURER,
} from '@api';

const dateFormat = 'YYYY-MM-DD';
const { TextArea } = Input;

class AddManufacturerModal extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      factoryName: '',
      taxCode: '',
      foreverFlag: 1,
      expireDate: undefined,
      businessLicenseFiles: [],
      produceLicenseFiles: [],
    };
  }

  componentDidUpdate(prevProps) {
    const { visible, form } = this.props;
    if (visible && !prevProps.visible) {
      this.setState({
        factoryName: '',
        taxCode: '',
        foreverFlag: 1,
        expireDate: undefined,
        businessLicenseFiles: [],
        produceLicenseFiles: [],
      });
      form.resetFields();
    }
  }

  handleFileChange = (field, info) => {
    const fileList = [...(info?.fileList || [])];
    const nextState = {
      [field]: fileList,
    };
    if (
      field === 'businessLicenseFiles' &&
      info?.file?.status === 'done' &&
      fileList.length === 1
    ) {
      const ocrData = fileList[0]?.response?.data || {};
      const { companyName, name, taxCode, validToDate } = ocrData;
      if (companyName || name) {
        nextState.factoryName = companyName || name;
      }
      if (taxCode) {
        nextState.taxCode = taxCode;
      }
      if (moment(validToDate, 'YYYYMMDD').isValid()) {
        nextState.expireDate = moment(validToDate, 'YYYYMMDD').format(dateFormat);
        nextState.foreverFlag = 0;
      }
    }
    this.setState(nextState);
  };

  handleConfirm = () => {
    const { onConfirm, form, sourceType } = this.props;
    const {
      // taxCode,
      // foreverFlag,
      // expireDate,
      // businessLicenseFiles,
      // produceLicenseFiles,
    } = this.state;

    form.validateFields((err, values) => {
      if (err) {
        return;
      }

      this.setState({
        addLoading: true,
      });
      getData({
        api: ADDMANUFACTURER,
        data: {
          factoryName: values.factoryName,
          sourceType,
        },
      })
        .then(res => {
          if (res.code === 200000) {
            onConfirm &&
              onConfirm({
                factoryName: values.factoryName,
                // taxCode,
                // foreverFlag,
                // expireDate,
                // businessLicenseFiles,
                // produceLicenseFiles,
              });
            this.handleCancel();
          }

          this.setState({
            addLoading: false,
          });
        })
        .finally(() => {
          this.setState({
            addLoading: false,
          });
        });
    });
  };

  handleCancel = () => {
    const { onCancel } = this.props;
    onCancel && onCancel();
  };

  render() {
    const { visible, form } = this.props;
    const { getFieldDecorator } = form;
    const {
      // factoryName,
      // taxCode,
      // foreverFlag,
      // expireDate,
      // businessLicenseFiles,
      // produceLicenseFiles,
      addLoading,
    } = this.state;
    const factoryName = form.getFieldValue('factoryName') || '';
    // 获取长度
    const length = factoryName.length;
    return (
      <Modal
        title="生产厂家-新增"
        visible={visible}
        width={620}
        destroyOnClose
        footer={null}
        maskClosable={false}
        onCancel={this.handleCancel}>
        <Form>
          <Form.Item label="厂家名称" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
            {getFieldDecorator('factoryName', {
              rules: [{ required: true, whitespace: true, message: '请输入' }],
            })(<TextArea placeholder="请输入" allowClear maxLength={100} showCount />)}
          </Form.Item>
          <div style={{ textAlign: 'right', marginTop: -15 }}>{length}/100</div>
          <Row span={24}>
            <Col span={24} style={{ textAlign: 'right' }}>
              <Button style={{ marginRight: 8 }} onClick={this.handleCancel}>
                取消
              </Button>
              <Button
                loading={addLoading}
                type="primary"
                htmlType="submit"
                onClick={this.handleConfirm}>
                确定
              </Button>
            </Col>
          </Row>
        </Form>
        {/* <Form.Item label="营业执照" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          <UploadImg
            multiple
            accept="application/pdf,image/jpg,image/jpeg,image/png"
            action={generateUrl(POST_FILE_UPLOAD_OCRWHITE)}
            fileList={businessLicenseFiles}
            onChange={file => this.handleFileChange('businessLicenseFiles', file)}
            maxCount={1}
            maxSize={5242880}
            headers={{
              'login-token': getVariantSession(LOGIN_TOKEN),
              'X-Requested-With': null,
            }}>
            {businessLicenseFiles.length >= 1 ? null : (
              <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
              </div>
            )}
          </UploadImg>
          <Radio.Group
            style={{ marginTop: 8 }}
            value={foreverFlag}
            onChange={e => this.setState({ foreverFlag: e.target.value })}>
            <Radio value={1}>永久</Radio>
            <Radio value={0}>非永久</Radio>
          </Radio.Group>
          {foreverFlag === 0 && (
            <DatePicker
              style={{ marginLeft: 10 }}
              value={expireDate ? moment(expireDate, dateFormat) : undefined}
              format={dateFormat}
              allowClear
              onChange={value =>
                this.setState({
                  expireDate: value ? moment(value).format(dateFormat) : undefined,
                })
              }
            />
          )}
        </Form.Item>
        <Form.Item label="社会信用统一码" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          <Input
            allowClear
            maxLength={18}
            value={taxCode}
            onChange={e => this.setState({ taxCode: e.target.value })}
          />
        </Form.Item>
        <Form.Item label="生产许可证" labelCol={{ span: 6 }} wrapperCol={{ span: 18 }}>
          <UploadImg
            multiple
            accept="application/pdf,image/jpg,image/jpeg,image/png"
            action={generateUrl(
              produceLicenseFiles.length === 0
                ? POST_FILE_UPLOAD_FOOD_PRODUCE_LICENSE_WHITE_OCRWHITE
                : POST_FILE_UPLOAD_WHITE,
            )}
            fileList={produceLicenseFiles}
            onChange={file => this.handleFileChange('produceLicenseFiles', file)}
            maxCount={10}
            maxSize={5242880}
            headers={{
              'login-token': getVariantSession(LOGIN_TOKEN),
              'X-Requested-With': null,
            }}>
            {produceLicenseFiles.length >= 10 ? null : (
              <div>
                <Icon type="plus" />
                <div className="ant-upload-text">Upload</div>
              </div>
            )}
          </UploadImg>
        </Form.Item> */}
      </Modal>
    );
  }
}

export default Form.create()(AddManufacturerModal);
